<template>
  <div :class="cn(variants({ size, color, type, radius }), props.class)">
    <Icon :name="name" :size="iconSize" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { cn } from "@/Utils/cn";
import { sizes, colors, types, radius as radiusTypes, variants } from ".";
import { Icon } from "@/SharedComponents/Icon";

const props = defineProps({
  class: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    validator: (val) => sizes.includes(val),
    default: "md",
  },
  color: {
    type: String,
    validator: (val) => colors.includes(val),
    default: "brand",
  },
  type: {
    type: String,
    validator: (val) => types.includes(val),
    default: "light",
  },
  name: {
    type: String,
    required: true,
  },
  radius: {
    type: String,
    validator: (val) => radiusTypes.includes(val),
    default: "full",
  },
});

const iconSize = computed(() => {
  switch (props.size) {
    case "2xl":
      return "4xl";
    case "xl":
      return "3xl";
    case "lg":
      return "2xl";
    case "md":
      return "xl";
    default:
      return "md";
  }
});
</script>
